import { ModuleRoutes } from '@kiplin/web-common/architecture-core';
import { loadLazyAppModuleGuard } from '@kiplin/web-common/dependency-injection';
import { LandingRouteName } from '@shared/feature/landing/application/routes/landing.route-name';
import type { Container } from 'inversify';
import type { RouteRecordRaw } from 'vue-router';

const LandingAppModule = () => import('@shared/feature/landing/landing.app-module');
const LandingErrorPage = () => import('@shared/feature/landing/application/page/LandingErrorPage.vue');
const DefaultLandingPage = () => import('@shared/feature/landing/application/page/DefaultLandingPage.vue');

export class LandingModuleRoutes extends ModuleRoutes<LandingRouteName> {
  constructor(container: Container) {
    const routes: RouteRecordRaw[] = [
      {
        path: '/landing-error',
        name: LandingRouteName.LandingError,
        component: LandingErrorPage,
        beforeEnter: [loadLazyAppModuleGuard(LandingAppModule, container)],
      },
      {
        path: '/default-landing',
        name: LandingRouteName.DefaultLanding,
        component: DefaultLandingPage,
        beforeEnter: [loadLazyAppModuleGuard(LandingAppModule, container)],
      },
    ];

    super(routes);
  }
}
